import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReassign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "reassign",
	"data-name": "reassign",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M20.5,12a8.5,8.5,0 1 1-2.49-6l2.99,2.99",
			id: "path-reassign-arc"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "21,3 21,9 15,9",
			id: "polyline-reassign-arrow"
		})
	]
});
const ForwardRef = forwardRef(SvgReassign);
export default ForwardRef;
